ckdc.ready(function () {
    let scrollY = window.scrollY;
    let videoIframe = document.querySelector('.iframe-sticky');
    let videoIframeCloseBtn = document.querySelector('.iframe-close-btn');
    let videoRef = document.querySelector('.iframe-ref-position');
    let recipeStepsList = document.querySelector('.recipe-steps-list');
    let videoClosed = false;

    function enableStickyVideo() {
        if (!videoClosed) {
            videoIframe.classList.add('iframe-sticky-on');
        }
    }

    function disableStickyVideo() {
        videoIframe.classList.remove('iframe-sticky-on');
    }

    function handleIframeRefIntersection(entries) {
        entries.map((entry) => {
            if (!entry.isIntersecting) {
                if (window.scrollY > scrollY) {
                    enableStickyVideo();
                } else {
                    disableStickyVideo();
                }
            } else {
                disableStickyVideo();
            }

            scrollY = window.scrollY;
        });
    }

    function handleRecipeStepsListIntersection(entries) {
        entries.map((entry) => {
            if (window.scrollY > scrollY) {
                enableStickyVideo();
            }
            scrollY = window.scrollY;
        });
    }

    if (videoRef) {
        const iframeRefObserver = new IntersectionObserver(
            handleIframeRefIntersection
        );
        iframeRefObserver.observe(videoRef);

        const recipeListObserver = new IntersectionObserver(
            handleRecipeStepsListIntersection
        );
        recipeListObserver.observe(recipeStepsList);
    }

    videoIframeCloseBtn.addEventListener('click', function () {
        videoClosed = true;
        disableStickyVideo();

        // Pause youtube video when closing iframe.
        if (videoIframe.classList.contains('iframe-youtube')) {
            const postMessageCommand = {
                event: 'command',
                func: 'pauseVideo',
                args: '',
            };

            videoIframe
                .querySelector('iframe')
                .contentWindow.postMessage(
                    JSON.stringify(postMessageCommand),
                    '*'
                );
        }

        // Pause vimeo video when closing iframe.
        if (videoIframe.classList.contains('iframe-vimeo')) {
            const postMessageCommand = {
                method: 'pause',
            };

            videoIframe
                .querySelector('iframe')
                .contentWindow.postMessage(
                    JSON.stringify(postMessageCommand),
                    '*'
                );
        }
    });
});
